import * as loanActions from '../actions/loan-actions';

const initialState = {
  errors: null,
  bill: null,
};

/**
 * Loan reducer.
 * @param {*} state Current state.
 * @param {*} action Action to be perfomed.
 */
export default function loanReducer(state = initialState, action) {
  // Processes new state.
  let newState;
  switch (action.type) {
    case loanActions.PAYMENT_CARD_SUCCESS:
      newState = {
        ...state,
        bill: action.payload,
        errors: [],
      };
      return newState;
    case loanActions.PAYMENT_CARD_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;
    case loanActions.REFRESH_BILL_SUCCESS:
      newState = {
        ...state,
        bill: action.payload,
      };
      return newState;
    case loanActions.REFRESH_BILL_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;
    case loanActions.GET_BILL_BAR_CODE_SUCCESS:
      newState = {
        ...state,
      };
      return newState;
    case loanActions.GET_BILL_BAR_CODE_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;

    default:
      return { ...state };
  }
}
